import type { TranslateFn } from 'src/localization/translate'
import type { CardManagementLifecycleOperationStatus } from 'src/queries/physicalCardManagement/physicalCardManagement.models'

type PhysicalCardLifecycleTerminalOutcome = {
  message: string
  failureColorScheme: boolean
}

export const getPhysicalCardLifecycleTerminalOutcome = (
  actionLabel: string,
  status: CardManagementLifecycleOperationStatus,
  translate: TranslateFn,
): PhysicalCardLifecycleTerminalOutcome => {
  if (status === 'SUCCEEDED') {
    return {
      message: translate('${action} completed successfully.', {
        action: actionLabel,
      }),
      failureColorScheme: false,
    }
  }
  if (status === 'CANCELED') {
    return {
      message: translate(
        '${action} was canceled. No changes were made to this card.',
        { action: actionLabel },
      ),
      failureColorScheme: false,
    }
  }
  return {
    message: translate(
      '${action} could not be completed. Review the card before trying again.',
      { action: actionLabel },
    ),
    failureColorScheme: true,
  }
}
